import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import { ContentInput } from 'api';
import { ValidatedCheckbox } from 'components';
import Tooltip from '@material-ui/core/Tooltip';
import { useProtectedClient } from 'hooks';
import { canBeShared } from 'features/posting/helpers';

const ShareableCheckbox: FC = () => {
  const { t } = useTranslation();
  const client = useProtectedClient();
  const { values } = useFormikContext<ContentInput>();
  const isSharingAvailable = canBeShared(client, values);

  return (
    <Tooltip
      disableHoverListener={isSharingAvailable}
      arrow
      title={t('posting:sharingTurnedOff')}
      placement="top"
    >
      <span>
        <ValidatedCheckbox
          disabled={!isSharingAvailable}
          name="is_shareable"
          label={t('posting:shareable')}
          color="primary"
        />
      </span>
    </Tooltip>
  );
};

export default ShareableCheckbox;
